import { render } from "./BillingPlanDetails.vue?vue&type=template&id=db4560c4&scoped=true"
import script from "./BillingPlanDetails.vue?vue&type=script&lang=js"
export * from "./BillingPlanDetails.vue?vue&type=script&lang=js"

import "./BillingPlanDetails.vue?vue&type=style&index=0&id=db4560c4&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db4560c4"]])

export default __exports__